import React from 'react'
import PropTypes from 'prop-types'
import 'font-awesome/css/font-awesome.css'

const ResourceEntry = (props) => {
  const statusIcon = "fa fa-circle fa-lg " + (props.statusOk ? "statusOk" : "statusFail")
  const deleteIcon = "fa fa-trash-o fa-lg"
  const busyIcon = "fa fa-clock-o fa-lg"
  const errorIcon = "fa fa fa-exclamation fa-lg"

  const deleteResource = (evt) => {
    evt.preventDefault()
    props.delete(props.url)
  }

  const statusSpan = (
    <span className="Status">
      <i className={statusIcon}/>
    </span>
  )

  const deleteSpan = (
    <span className="DomainResourceAction i-btn">
      <i className={deleteIcon} onClick={deleteResource}/>
    </span>
  )

  const busySpan = (
    <span className="DomainResourceAction">
      <i className={busyIcon}/>
    </span>
  )

  const errorSpan = (
    <span className="DomainResourceAction">
      <i className={errorIcon}/>
    </span>
  )

  const emptySpan = (
    <span className="DomainResourceAction"/>
  )
	
	return (
		<div className="ResourceEntry">
      {statusSpan}
      <span className="Name">{props.name}</span>
      {
        props.error ? errorSpan : (
          props.busy ? busySpan : (
            props.editable ? deleteSpan :
              emptySpan
          )
        )
      }
		</div>
	)
}

ResourceEntry.propTypes = {
	url: PropTypes.string.isRequired,
	name: PropTypes.string.isRequired,
	statusOk: PropTypes.bool.isRequired,
  editable: PropTypes.bool.isRequired,
	delete: PropTypes.func.isRequired,
  busy: PropTypes.bool,
  error: PropTypes.bool,
}

ResourceEntry.defaultProps = {
  busy: false,
  error: false,
}

export default ResourceEntry


// WEBPACK FOOTER //
// ./src/components/ResultTable/ResourceEntry.js